module.exports = "/images/adress-vector_mobile.svg?7302511d7952f5c2354e75bf6acb20de";